// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import Mint from 'mint-ui'
Vue.use(Mint)

// import NutUI from '@nutui/nutui';
// import '@nutui/nutui/dist/style.css';
// NutUI.install(Vue);

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Vueresource from 'vue-resource'
Vue.use(Vueresource)

// 1、创建组件
import Authtest from './components/authtest.vue'
import Baseinfo from './components/baseinfo.vue'
import Appointment from './components/appointment.vue'
import AppointmentOnline from'./components/appointmentonline.vue'
import AppointmentOnlinetest from'./components/appointmentonlinetest.vue'
import Submitappointment from './components/submitappointment.vue'
import Dispqueuinfo from './components/Dispqueuinfo.vue'
import Queulist from './components/queulist.vue'
import Appointmentlist from './components/appointlist.vue'
import Personinfo from './components/personinfo.vue'
import Ticketlist from './components/Ticketlist.vue'
import Electicketlist from './components/Electicketlist.vue'
import Ownlist from './components/ownlist.vue'
import Selectseat from './components/Selectseat.vue'
import Err from './components/err.vue'

// 2、配置路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// 我们晚点再讨论嵌套路由。
const routes = [
  { path: '/appointment', component: Appointment },
  { path: '/appointmentonline', component: AppointmentOnline },
  { path: '/appointmentonlinetest', component: AppointmentOnlinetest },
  { path: '/authtest', component: Authtest },     // 动态路由
  { name:'baseinfo',path: '/baseinfo', component: Baseinfo },  
  // { path: '/submitappointment', component: Submitappointment },
  { name:'submitappointment',path: '/submitappointment', component: Submitappointment },
  { name:'dispqueuinfo',path: '/dispqueuinfo', component: Dispqueuinfo },
  { path: '/queulist', component: Queulist },
  { path: '/appointmentlist', component: Appointmentlist },
  { name:'personinfo',path: '/personinfo', component: Personinfo },
  { name:'ticketlist',path: '/ticketlist', component: Ticketlist },
  { name:'electicketlist',path: '/Electicketlist', component: Electicketlist },
  { name:'ownlist',path: '/Ownlist', component: Ownlist },
  { name:'selectseat',path: '/selectseat', component: Selectseat },
  { path: '/err', component: Err },
  { path: '*', redirect:'/ticketlist'}          // 默认跳转路由
]


// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js